<template>
  <div id="app" class="app">
    <template v-if="isShowHeader">
      <Header />
      <div class="page-center">
        <router-view />
      </div>
      <Footer />
      <!-- <div class="ai crr" v-if="showAi">
        <img src="@/assets/img/ai.png" alt="" @click="openAi">
      </div> -->
    </template>
    <router-view v-else />
    <!-- 登录 -->
    <div class="logintip d-flex a-center j-center" v-if="$store.state.showLoginTip">
      <div class="apploginbox">
        <Login />
      </div>
    </div>
    <div class="logintip d-flex a-center j-center" v-if="$store.state.showRegisterTip">
      <div class="apploginbox">
        <Register />
      </div>
    </div>
    <!-- 角色 -->
    <div class="logintip d-flex a-center j-center" v-if="$store.state.showChangeRole">
      <Role />
    </div>
  </div>
</template>

<script>
import Header from './components/header/index.vue'
import Footer from './components/footer/index.vue'
import Login from './components/login/login.vue'
import Register from './components/login/register.vue'
import Role from './components/role/role.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Login,
    Register,
    Role
  },
  data() {
    return {
      isShowHeader: true,
      showAi: true,
    }
  },
  watch: {
    $route (newVal) {
      // if (
      //   this.$route.path !== '/login' &&
      //   this.$route.path !== '/register' &&
      //   this.$route.path !== '/forget-pwd' &&
      //   this.$route.path !== '/error'
      // ) {
      //   const token = localStorage.getItem('token')
      //   if (!token) {
      //     this.$router.push('/login')
      //     return this.$utils.MessageText('请先登录后再进行操作')
      //   }
      // }
      // 登录注册及选择店铺
      if (this.$route.path === '/login' || this.$route.path === '/ai') {
        this.isShowHeader = false
      } else {
        this.isShowHeader = true
      }
      if (this.$route.meta.showAi) {
        this.showAi = true
      } else {
        this.showAi = false
      }
    }
  },
  methods: {
    openAi() {
      // const { href } = this.$router.resolve({
      //   path: `/ai`
      // });
      const href = 'https://ai.aifoodedu.com/chat/9d988231b8ace06e'
      window.open(href, '_blank');
    }
  }
}
</script>

<style lang="scss">
.app{
  min-height: 100%;
  position: relative;
}
.page-center{
  min-height: calc(100vh - 200px);
  box-sizing: border-box;
  // background: #f6f6f6;
  padding: 1px 0 167px;
}
.ai{
  position: fixed;
  top: 670px;
  z-index: 1;
  img{
    width: 113px;
  }
}
@media only screen and (min-width: 1553px) {
  .ai{
    right: 50%;
    top: 700px;
    margin-right: -880px;
  }
}
@media only screen and (max-width: 1553px) {
  .ai{
    right: 0;
  }
}
.logintip{
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0,0,0,0.5);
  .apploginbox{
    padding: 1.25rem 1.875rem;
    border-radius: 0.3125rem;
    background: #FFFFFF;
    position: relative;
  }
  .closeico{
    font-size: 1.25rem;
    position: absolute;
    right: 0.625rem;
    top: 0.625rem;
    cursor: pointer;
  }
}
*{
  margin: 0;
  padding: 0;
  list-style: none;
}
html{
  font-size: 16px;
  color: #333;
  min-width: 75rem;
}
button{
  outline: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}
input{
  background: none;
  border: none;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
}
img{
  margin: 0;
  padding: 0;
  font-size: 0;
}
</style>
